import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AddUserToProducerCenterByInvitation,
  GetProducerCenterWalletPriceNT,
  GetUserProducerCenterNT,
} from "../../auth/core/_requests";
import { useNavigate } from "react-router-dom";
import { useAuth, UserProducerCenter } from "../../auth";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSetUserProducerCenterSpecificationAndWallet } from "../../producerCenter/components/useSetUserProducerCenterSpecificationAndWallet";
import { useTranslation } from "react-i18next";

function InvitationCheck() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { currentUser, saveUserProducerCenter } = useAuth();
  const { setUserProducerCenterSpecificationAndWallet } =
    useSetUserProducerCenterSpecificationAndWallet();
  const navigate = useNavigate();

  const findCodeInQuery = () => {
    const code = searchParams.get("code");

    if (code && currentUser) {
      checkForInvitation(code);
      fetchAndSaveProducerCenter();
    } else {
    }
  };

  const checkForInvitation = async (code: string) => {
    try {
      const results = await AddUserToProducerCenterByInvitation(code);

      if (results?.data?.isSuccess) {
        showSwal();
      } else {
        console.error("Invitation check failed. Response data:", results?.data);
        const errorMessage = results?.data?.message || t("AUTH.REGISTER_LOGIN.INVITE_CHECK_ERROR");
        alert(errorMessage);
      }
    } catch (error) {
      console.error("Error during invitation check:", error);
      alert(t("AUTH.REGISTER_LOGIN.INVITE_CHECK_ERROR"));
    }
  };

  const fetchAndSaveProducerCenter = async () => {
    try {
      const getUserProducerCenter = await GetUserProducerCenterNT();

      if (getUserProducerCenter.data?.isSuccess) {
        const data = getUserProducerCenter.data.data;
        const userProducerCenter: UserProducerCenter = {
          producerCenterId: data.producerCenterId,
          name: data.name,
          code: data.code,
          icon: data.icon,
          isMaster: data.isMaster,
          walletPrice: 0,
        };

        const getProducerCenterWallet = await GetProducerCenterWalletPriceNT(
          data.producerCenterId
        );

        if (getProducerCenterWallet.data?.isSuccess) {
          userProducerCenter.walletPrice =
            getProducerCenterWallet.data.data.walletPrice;
        }

        saveUserProducerCenter(userProducerCenter);
      }
    } catch (error) {
      console.error("Error fetching producer center:", error);
    }
  };

  const showSwal = () => {
    withReactContent(Swal).fire({
      title: <i>{t("AUTH.REGISTER_LOGIN.INVITE_CONFIRMED")}</i>,
      timer: 3000,
      icon: "success",
      showConfirmButton: true,
      confirmButtonText: t("AUTH.REGISTER_LOGIN.OK"),
    });
  };

  useEffect(() => {
    findCodeInQuery();
    // Inner async function to handle async/await in useEffect
    // Conditional navigation based on user status after code execution
    if (currentUser) {
      navigate("/dashboard");
    } else {
      navigate("/auth/verify-phonenumber");
    }
  }, [currentUser, navigate]);

  return null;
}

export default InvitationCheck;
